/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Apr 30 2024
 **/

import styled from "@emotion/styled";
import { AllHTMLAttributes } from "react";

import { Column, Typography } from "@/frameworks/designStuff/components";
import { filterHTMLAttribute } from "@/frameworks/libraries/utilities";
import { _T } from "@rfice/language";
import { useSpaceChannelState, useSpaceRoomState } from "@/frameworks/core/chat";
import { useProperties } from "@/frameworks/libraries/properties";

interface SpaceChatAvatarProps extends AllHTMLAttributes<HTMLButtonElement> {
	spaceID: string;
	roomID: string;
}

export default function SpaceChatAvatar(props: SpaceChatAvatarProps) {
	const space = useSpaceChannelState(props.spaceID);
	const spaceChatRoom = useSpaceRoomState(props);
	const properties = useProperties();

	return (
		<StyledSpaceChatAvatar
			verticalAlign="center"
			horizonAlign="center"
			{...filterHTMLAttribute(props)}
			thumbnailPath={`${properties.default.webDomain}${space?.thumbnailPath}`}
		>
			<Typography typoColor="neutral_00_100" typoSize="Body6" stretch ellipsis maxLine={1}>
				{space?.myRoom ? _T("마이룸") : space?.spaceName}
			</Typography>
			<Typography typoColor="neutral_00_100" typoSize="Body6" stretch ellipsis maxLine={1}>
				{spaceChatRoom?.roomName}
			</Typography>
		</StyledSpaceChatAvatar>
	);
}

const StyledSpaceChatAvatar = styled(Column.button)<{ thumbnailPath?: string }>`
	width: 48px;
	height: 48px;
	border-radius: 12px;
	padding: 6px 3px;
	background-image: url(${({ thumbnailPath }) => thumbnailPath});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	cursor: pointer;
	span {
		text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);
	}
`;
